import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import PropTypes from 'prop-types';
import TableDopFilter from './lineTableFilter';
import _ from 'lodash';
import { numberFormat } from '../../common';

const GameId = React.createContext(0);

@inject('lineStore', 'accountStore')
@observer
class Td extends Component {

  static contextTypes = {
    gid: PropTypes.number
  }

  componentDidUpdate(prevProps) {
    if (this.props.type == 'cf' && prevProps.cf && this.props.accountStore.accountSettings.highlightChangesLive && this.props.lineStore.mode == 'live') {
      if (prevProps.cf != this.props.cf) {
        prevProps.cf < this.props.cf ? this.animate('b-green') : this.animate('b-orange');
      }
    }
  }

  animate = (a) => {
    if (this.cell) {
      // this.cell.classList.remove('b-green', 'b-orange');
      this.cell.classList.add(a);
      setTimeout(() => { if (this.cell) { this.cell.classList.remove('b-green', 'b-orange') } }, 2500);
    }
  }

  doBet = () => {
    const { mode } = this.props.lineStore.line;
    if (mode === 'line') {
      localStorage.setItem('lastAction', 1);
    } else {
      localStorage.setItem('lastAction', 0);
    }
    this.props.lineStore.basket.newAddOdd(this.props.oddKey, this.props.gid);
  }

  render() {
    const { type, cf, status, rws, id, gid, width, oddKey } = this.props;
    let select = 0;
    if (this.props.lineStore.basket.basketData.oddsIds.has(oddKey)) {
      select = 1;
    };
    if (type == 'cf') {
      return (!status ? <td style={{ width: `${width}%` }} className={type} ref={el => { this.cell = el }} ><a className={`g-b ${select ? 'g-b-s' : ''}`} onClick={this.doBet} dangerouslySetInnerHTML={{ __html: numberFormat(cf, 2, ',', ' ') }}></a></td> : <td style={{ width: `${width}%` }} className={type} ><span className="g-b-b" dangerouslySetInnerHTML={{ __html: numberFormat(cf, 2, ',', ' ') }}></span></td>)
    } else {
      return <td style={{ width: `${width}%` }} rowSpan={rws} dangerouslySetInnerHTML={{ __html: cf }}></td>
    }
  }
};

const Tr = ({ data }) => (
  <tr>
    {data.map((item, id) =>
      <GameId.Consumer>
        {value => (
          <Td
            oddKey={item.oddKey}
            key={item.id}
            id={item.id}
            rws={item.rws}
            type={item.t}
            cf={item.h}
            status={item.st}
            gid={value}
            width={item.w}
          />
        )}
      </GameId.Consumer>)
    }
  </tr>
);

const Tbody = ({ data }) => (
  <tbody>
    {data.ch.map((item, id) => <Tr key={id} data={item.ch} />)}
  </tbody>
);

const Th = ({ cls, h, align, width }) => {
  let clN = '';
  if (align === 'center') {
    clN = 'g-t-v-th-a-c';
  } else if (align === 'right') {
    clN = 'g-t-v-th-a-r';
  } else if (align === 'left') {
    clN = 'g-t-v-th-a-l';
  }
  return (
    <th className={clN} colSpan={cls} style={{ width: `${width}%` }} title={h}>{h}</th>
  )
}

const Thead = ({ data, id }) => (
  <thead>
    <tr>
      {data.map((item, idx) => (
        <Th
          key={`${id}${item.h}`}
          cls={item.cls}
          h={item.h}
          width={item.w}
          align={item.align}
        />
      ))}
    </tr>
  </thead>
);

const Table = ({ data, show, id, gid }) => (
  <div className={`g-t-v-d ${!show ? 'hidden' : ''}`} id={`table_${id}`}>
    <table className="g-t-v">
      {/* <Thead id={id} data={data.ch[0].ch} />
        <Tbody data={data.ch[1]} />*/}
      {data.ch.map(el =>
        el.header ?
          <Thead data={el.ch} key={`table_head_${id}_${gid}`} id={id} /> :
          <Tbody data={el} key={`table_body_${id}_${gid}`} />
      )
      }
    </table>
  </div>
);


@inject('lineStore')
@observer
class Tables extends Component {

  render() {
    const { mode, line } = this.props.lineStore;
    const { filterTables, hideTables, favTables, lineGames } = line;

    let show = 1;
    const filter = filterTables.get(this.props.id);

    if (filter) {
      if (filter.fav_select) {
        const { sid } = lineGames.get(this.props.id);
        show = favTables.get(sid).tids.indexOf(this.props.tid) !== -1 ? 1 : 0;
      } else if ((filter.filter[0] || {}).select != 1) {
        const data = toJS(filter.filter);
        let tidsArray = [];
        for (const i in data) {
          if (
            data[i].select &&
            data[i].tids &&
            data[i].tids.length > 0 &&
            Array.isArray(data[i].tids)
          ) {
            tidsArray = tidsArray.concat(data[i].tids);
          }
        }
        if (!tidsArray.includes(this.props.tid)) {
          show = 0;
        }
      }
    }

    return (
      <GameId.Provider value={this.props.id}>
        <Table data={this.props.item.ch[0]} show={show} id={this.props.item.data.id} gid={this.props.id} />
      </GameId.Provider>
    )
  }
}

@inject('lineStore')
@observer
export default class TableDop extends Component {

  render() {
    const lineStore = this.props.lineStore.line;
    const gameID = this.props.id;
    const statisticalGameID = lineStore.getActiveStatisticalCategoryID(gameID);
    const isStatisticalCategoryTablesLoading = lineStore.statisticalCategoriesLoading.includes(gameID);
    const hasStatistic = !!(lineStore.lineGames.get(gameID) || {}).statistical_ids;
    const other = lineStore.lineGamesOther.get(this.props.id);

    return (
      <tr className="g-a-tr">
        <td colSpan="21">
          <TableDopFilter id={gameID} />
          {hasStatistic && isStatisticalCategoryTablesLoading
            ? null
            : (
              <Fragment>
                <ColumnTables gid={statisticalGameID} count={lineStore.colCount} />
                {other ? <Add data={other} /> : ''}
              </Fragment>
            )
          }
        </td>
      </tr>
    )
  }
}

@inject('lineStore', 'accountStore')
@observer
class ColumnTables extends Component {
  render() {
    const lineStore = this.props.lineStore.line;
    /**
     * Если таблицы доп.исходов получили по ws,
     * возвращаем их, иначе - старый компонент
     */
    const { count, gid } = this.props;
    const data = lineStore.lineGamesDetails.get(gid);
    if (!data) { return null; }
    return (
      data.order.map(item =>
        <div className={`g-r-d-col g-r-d-col-${count}`}>
          {item.map(id =>
            data.data[id] ? <Tables key={`${id}_${gid}`} id={gid} item={data.data[id]} tid={id} /> : ''
          )}
        </div>
      )
    )
  }
}

@inject('dictStore')
@observer
class Add extends Component {
  render() {

    const { getLang } = this.props.dictStore;
    const { data } = this.props;

    return (
      <div className="g-a-other">
        <b>{getLang('ADDITIONAL_BETS')}</b>: {` `}
        {
          data.map(el => {
            return <Bet cf={el.cf} key={el.id} name={el.name} id={el.id} gid={el.gid} oddKey={el.oddKey} />
          }
          )
        }
      </div>
    )
  }
}

@inject('lineStore', 'accountStore')
@observer
class Bet extends Component {

  componentDidUpdate(prevProps) {
    if (prevProps.cf && this.props.accountStore.accountSettings.highlightChangesLive && this.props.lineStore.mode == 'live') {
      if (prevProps.cf != this.props.cf) {
        prevProps.cf < this.props.cf ? this.animate('b-green') : this.animate('b-orange');
      }
    }
  }

  animate = (a) => {
    if (this.cell) {
      this.cell.classList.add(a);
      setTimeout(() => { if (this.cell) this.cell.classList.remove('b-green', 'b-orange') }, 2500);
    }
  }

  doBet = () => {
    this.props.lineStore.basket.newAddOdd(this.props.oddKey, this.props.gid);
  }

  render() {
    const { name, cf, gid, id, oddKey } = this.props;
    let select = 0;
    if (this.props.lineStore.basket.basketData.oddsIds.has(oddKey)) {
      select = 1;
    }
    return (
      <Fragment>
        {name} -  <a className={`g-b ${select ? 'g-b-s' : ''}`} onClick={this.doBet} dangerouslySetInnerHTML={{ __html: numberFormat(cf, 2, ',', ' ') }}></a>;{` `}
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/line/lineTableDop.js